import dayjs from "dayjs-local";

export interface DeviceReference {
  deviceId: string;
  siteId: string;
  unitId: string;
}

export enum DevicePackDataState {
  Fault = "fault",
  Connected = "connected",
  Disconnected = "disconnected",
}

export interface DeviceByTypeData {
  device_id: string;
  unit_id: string;
  grid_current_a: number;
  grid_voltage_v: number;
  timestamp_utc: string;
  cell_temperature_median_c: number;
  pack_soc_kwh_pct?: number;
  pack_soc_ah_pct?: number;
  pack_soh_kwh_pct?: number;
  pack_soh_ah_pct?: number;
  state: DevicePackDataState;
}

export const deviceOnlineInterval = 60000 * 1.5;
export const isDeviceOnline = (
  lastSeen: dayjs.Dayjs | undefined,
  currentTime: number
) =>
  (lastSeen && lastSeen.valueOf() > currentTime - deviceOnlineInterval) ||
  false;

export { DeviceStatus } from "./components/DeviceStatus";
